import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "15",
  height: "3"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<circle cx=\"1.5\" cy=\"1.5\" r=\"1.5\"><animate attributeName=\"opacity\" begin=\".1\" dur=\"1s\" repeatCount=\"indefinite\" values=\"0;1;0\"></animate></circle><circle cx=\"7.5\" cy=\"1.5\" r=\"1.5\"><animate attributeName=\"opacity\" begin=\".2\" dur=\"1s\" repeatCount=\"indefinite\" values=\"0;1;0\"></animate></circle><circle cx=\"13.5\" cy=\"1.5\" r=\"1.5\"><animate attributeName=\"opacity\" begin=\".3\" dur=\"1s\" repeatCount=\"indefinite\" values=\"0;1;0\"></animate></circle>", 3)
  ])))
}
export default { render: render }